<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-truck"></i> 供应商管理</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-form-item label="供应商名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入供应商名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >新增</el-button
          >
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="供应商名称" prop="name"></el-table-column>
        <el-table-column label="联系人" prop="contactor"></el-table-column>
        <el-table-column label="联系方式" prop="mobile"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="创建人" prop="creatorName"></el-table-column>
        <el-table-column label="操作" width="150">
          <template v-slot="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="deleteSupplier(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        @close="resetForm"
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑供应商' : '新增供应商'"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="currentSupplier"
          ref="form"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="供应商名称" prop="name">
            <el-input
              v-model="currentSupplier.name"
              placeholder="请输入供应商名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input
              v-model="currentSupplier.contactor"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              v-model="currentSupplier.mobile"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveSupplier">{{
            isEdit ? "更新" : "确定"
          }}</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { supplierList, supplierAddOrEdit, supplierDelete } from "@/api/config";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      queryParams: {
        name: "",
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      allData: [],
      rules: {
        name: [
          { required: true, message: "供应商名称是必填项", trigger: "blur" },
        ],
      },
      tableData: [],
      dialogVisible: false,
      currentSupplier: {
        name: "",
        contactor: "",
        mobile: "",
      },
      isEdit: false,
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    resetForm() {
      this.currentSupplier = {
        name: "",
        contactor: "",
        mobile: "",
      };
      // 重置表单及校验状态
      this.$refs.form.resetFields();
    },
    handleQuery(page) {
      const { name } = this.queryParams;
      this.currentPage = page || 1;
      supplierList({
        name,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams.name = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false;
      this.currentSupplier = {
        name: "",
        contactor: "",
        mobile: "",
      };
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.currentSupplier = { ...row };
      this.dialogVisible = true;
    },
    saveSupplier() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {};
          params = { ...this.currentSupplier };
          if (this.isEdit) {
            params.id = this.currentSupplier.id; // 编辑时传 id
          }
          // 如果你需要调用接口，就取消下面这行注释
          supplierAddOrEdit(params).then(() => {
            this.dialogVisible = false;
            this.handleQuery();
            this.$message.success("操作成功");
          });
        } else {
          return false;
        }
      });
    },
    deleteSupplier(row) {
      this.$confirm("确定删除此供应商？", "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          supplierDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
